export class Storage {
    static set(key, value, isLocal = true) {
        if (isLocal) {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    }
    static get(key, isLocal = true) {
        if (isLocal) {
            return localStorage.getItem(key);
        }
        return sessionStorage.getItem(key);
    }
    static remove(key, isLocal = true) {
        if (isLocal) {
            localStorage.removeItem(key);
        } else {
            sessionStorage.removeItem(key);
        }
    }
    static clearAll(isLocal = true) {
        let clearKeys = ['routePaths', 'TENANT_KEY', 'userInfo'];
        if (isLocal) {
            Object.keys(localStorage).forEach(function (key) {
                if (clearKeys.includes(key)) {
                    localStorage.removeItem(key);
                }
            });
        } else {
            Object.keys(sessionStorage).forEach(function (key) {
                if (clearKeys.includes(key)) {
                    sessionStorage.removeItem(key);
                }
            });
        }
    }

    static clearAllExcept = (exceptKeys) => {
        Object.keys(localStorage).forEach(function (key) {
            if (!exceptKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });
    };
    static getCurrentTimeStamp() {
        return Date.now();
    }
    static setStorage(key, value, duration) {
        // 过期时间：0 = 永久有效
        const expiryTime = !duration || isNaN(duration) ? 0 : this.getCurrentTimeStamp() + duration * 1000; // 转毫秒
        const data = {
            value: value,
            expiryTime: expiryTime
        };
        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            console.error('存储失败（可能超出容量）：', e);
        }
    }
    static getStorage(key) {
        // 1.获取localStorage 里面的值
        const data = localStorage.getItem(key);
        if (!data) return null;
        const now = this.getCurrentTimeStamp();
        let obj;
        // 2. 解析存储的值
        try {
            obj = JSON.parse(data);
        } catch (e) {
            return null;
        }
        // 3. 没有过期时间 → 需求要求没有过期时间视为无效，过期自动删除
        if (!obj.expiryTime) {
            localStorage.removeItem(key);
            return null;
        }
        // 4. 已过期 → 删除并返回 null
        if (now > obj.expiryTime) {
            localStorage.removeItem(key);
            return null;
        }
        // 5. 未过期 → 返回值
        return obj.value;
    }
    static removeStorage(key) {
        localStorage.removeItem(key);
    }
}
